import {
  GET_COMMISSION,
  DELETE_COMMISSION,
  GET_COMMISSION_TYPE,
  DELETE_COMMISSION_TYPE,
  GET_COMMISSION_CATEGORY,
  DELETE_COMMISSION_CATEGORY,
} from "../actions/types";

const initialState = {
  commissionList: [],
  typeList: [],
  categoryList: [],
};

export default function (state = initialState, action) {
  switch (action.type) {
    case GET_COMMISSION:
      return {
        ...state,
        commissionList: action.payload.data,
      };

    case DELETE_COMMISSION:
      return {
        ...state,
        commissionList: state.commissionList.filter(
          (item) => item.id !== action.id,
        ),
      };

    case GET_COMMISSION_TYPE:
      return {
        ...state,
        typeList: action.payload.data,
      };

    case DELETE_COMMISSION_TYPE:
      return {
        ...state,
        typeList: state.typeList.filter((item) => item.id !== action.id),
      };

    case GET_COMMISSION_CATEGORY:
      return {
        ...state,
        categoryList: action.payload.data,
      };

    case DELETE_COMMISSION_CATEGORY:
      return {
        ...state,
        categoryList: state.categoryList.filter(
          (item) => item.id !== action.id,
        ),
      };

    default:
      return state;
  }
}
